import { gql } from '@apollo/client';

const MUTATION_DELETE_ASSETS = gql`
  mutation DeleteAssets($assetIds: [ID!]!) {
    assetsDelete(input: { assetIds: $assetIds }) {
      deletedIds
      errors {
        message
        path
        error
      }
    }
  }
`;

export default MUTATION_DELETE_ASSETS;
